import React, { useEffect, useState } from 'react';
import { clientNetwork, cryptoCashCoreAddress, stacksApi } from '../../lib/constants';
import { callReadOnlyFunction, cvToValue, principalCV, uintCV } from '@stacks/transactions';
import { authenticatedUserAddress } from '../../services/auth';
import { validateUsersContract } from '../../services/stacks';
import { useNavigate } from 'react-router-dom';
import ConfirmModal from '../../components/modal/ConfirmModal';
import { Alert, Box, Button, Snackbar } from '@mui/material';
import UserContractDeployModal from '../../components/modal/UserContractDeployModal';
import { network } from '../../services/auth';
import axios from 'axios';
import AddRemoveClaims from './addRemoveClaims';
import './style.scss'
import SingleClaim from './singleClaim';
import LongListClaim from './longListClaim';
/**
 * Application home page component
 * @returns {JSX}
 */

const style_elBackground = {
    width: '100%',
    height: '100%',
};
const style_elBackground_outer = {
    boxSizing: 'border-box',
    backgroundColor: '#0c2321',
};
function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <div>{children}</div>
                </Box>
            )}
        </div>
    );
}

const StackRewards = ({ userSettings }) => {
    // App loading states
    const [loading, setLoading] = useState(true);
    // Modals states
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [showUserContractDeployModal, setShowUserContractDeployModal] = useState();
    // tx states
    const [txId, setTxId] = useState();
    const [confirmTx, setConfirmTx] = useState();
    // Contract states
    const [userContractStatus, setUserContractStatus] = useState(null);
    // Stack history data states
    const [stackHistory, setStackHistory] = useState([]);

    const [userId, setUserId] = useState(null);
    const [currentCycle, setCurrentCycle] = useState(0);
    const [stackOffset, setStackOffset] = useState(0);

    const [longClaimList, setLongClaimList] = useState([]);

    // Error handler state's
    const [openSnackBar, setOpenSnackBar] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');

    // Pagination ends states
    const [stackPageEnded, setStackPageEnded] = useState(false);

    // Navigation function
    const navigate = useNavigate();
    const navTo = (to_txId) => {
        navigate(`/${to_txId}`);
    }

    // Stacking data construct function
    const requestStackingHistory = async () => {
        let stacksBlock, id = userId; let activeCycle = currentCycle;
        setLoading(true);
        try {
            // Fetching current stacks blockheight
            stacksBlock = (await axios.get(`${stacksApi}/extended/`)).data;
            stacksBlock = stacksBlock?.chain_tip?.block_height;

            const authUser = authenticatedUserAddress({ network: clientNetwork });

            // construct activeCycle if init value's are set to null
            if (!activeCycle) {
                let rewardCycle = await callReadOnlyFunction({
                    contractAddress: cryptoCashCoreAddress.split('.')[0], contractName: cryptoCashCoreAddress.split('.')[1],
                    functionName: 'get-reward-cycle',
                    functionArgs: [uintCV(stacksBlock)], network: network({ network: clientNetwork }), senderAddress: authUser
                });
                activeCycle = parseInt(cvToValue(rewardCycle)?.value);
            }

            if (stackOffset >= activeCycle) {
                setStackPageEnded(true);
                setLoading(false);
                return;
            }

            // construct userId if init value's are set to null
            if (!id) {
                const { value: { value: user_id } } = await callReadOnlyFunction({
                    contractAddress: cryptoCashCoreAddress.split('.')[0], contractName: cryptoCashCoreAddress.split('.')[1],
                    functionName: 'get-user-id', functionArgs: [principalCV(authUser)],
                    network: network({ network: clientNetwork }), senderAddress: authUser
                });
                id = user_id;
            }

            const pastCycle = activeCycle - 1;
            let cycleInfo = [];
            for (let x = stackOffset; x < pastCycle && cycleInfo.length < 5; x++) {
                // Delay each iteration by 1 second (adjust as needed)
                await new Promise(resolve => setTimeout(resolve, 5000));

                const res = await callReadOnlyFunction({
                    contractAddress: cryptoCashCoreAddress.split('.')[0],
                    contractName: cryptoCashCoreAddress.split('.')[1],
                    functionName: 'get-stacker-at-cycle',
                    functionArgs: [
                        uintCV((parseInt(pastCycle) - x)),
                        uintCV(id)
                    ],
                    network: network({ network: clientNetwork }),
                    senderAddress: authUser
                });

                cycleInfo.push(x);

                if (cvToValue(res) !== null) {
                    const stackReward = await callReadOnlyFunction({
                        contractAddress: cryptoCashCoreAddress.split('.')[0],
                        contractName: cryptoCashCoreAddress.split('.')[1],
                        functionName: 'get-stacking-reward',
                        functionArgs: [
                            uintCV(id),
                            uintCV((parseInt(pastCycle) - x))
                        ],
                        network: network({ network: clientNetwork }),
                        senderAddress: authUser
                    })
                    const { value: { amountStacked: { value: amount_stacked }, toReturn: { value: to_return } } } = cvToValue(res);
                    setStackHistory(prev => [...prev, {
                        cycle: (parseInt(pastCycle) - x),
                        userId: id, toReturn: to_return, stacked: amount_stacked,
                        claimable: (to_return > 0) && activeCycle > pastCycle,
                        reward: parseInt(cvToValue(stackReward))
                    }]);
                } else {
                    setStackHistory(prev => [...prev, {
                        cycle: (parseInt(pastCycle) - x),
                        userId: id, toReturn: 0, stacked: 0,
                        claimable: false,
                        reward: 0
                    }]);
                }
            }
            setUserId(id);
            setCurrentCycle(activeCycle);
            setStackOffset(prev => prev + 5);
            setLoading(false);
        } catch (error) {
            setErrorMsg(`${error.message}, slow down`);
            setOpenSnackBar(true);
            setLoading(false);
        }
    }

    async function init() {
        const { state, txId } = await validateUsersContract()
        if (state === false) {
            setUserContractStatus(state);
            setShowUserContractDeployModal(true);
        } else if (state === 'success' || state === 'mempool') {
            setTxId(txId);
            setUserContractStatus(state);
            setShowUserContractDeployModal(true);
        } else if (state === 'abort_by_post_condition' || state === 'abort_by_response') {
            setUserContractStatus("failed");
            setShowUserContractDeployModal(true);
        } else {
            setUserContractStatus(state);
            requestStackingHistory();
        }
    }

    useEffect(() => {
        init()
    }, [])

    useEffect(() => {
        setStackPageEnded(stackOffset >= currentCycle);
    }, [stackOffset, currentCycle])

    return (
        <>
            <div className="rewards-container" >

                <div className="background">
                    <div className="containerMinHeight elBackground" style={style_elBackground_outer}>
                        <div className="appBg" style={style_elBackground} />
                    </div>
                </div>

                <div className="rewards-items" >
                    <Box id="rewards-box"
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignContent: 'center',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '100%'
                        }}>
                        {/* Stacking */}
                        <CustomTabPanel id="rewards-panel">
                            <div className='filter-container'>

                                <LongListClaim longClaimList={longClaimList} />

                                <div className='right-content'>
                                    <label>Active Cycle: {currentCycle}</label>
                                </div>
                            </div >
                            <hr className='hr-tag' />

                            {
                                stackHistory && stackHistory.map(({ cycle, claimable, toReturn, stacked, reward }, index) => (
                                    <div style={{
                                        borderTopLeftRadius: '15px',
                                        borderTopRightRadius: '15px',
                                        backgroundImage: 'linear-gradient(to right, #F7931A , #6444fe)',
                                        marginBottom: '1rem',
                                        height: '3rem',
                                        alignContent: 'center'
                                    }} id="panel1-header" key={index}>
                                        <div id="accordion-summary">

                                            <div id="stack-iterms" >
                                                {cycle}
                                                <small>cycle</small>
                                            </div>

                                            <div id="stack-iterms" >
                                                <div>{stacked} {claimable && <img src="/32-cc.png" />}</div>
                                                <small>stacked</small>
                                            </div>

                                            <div id="stack-iterms" >
                                                {toReturn}
                                                <small>to return</small>
                                            </div>

                                            <SingleClaim navTo={navTo} cycleId={cycle} reward={claimable} setConfirmTx={setConfirmTx} setShowConfirmModal={setShowConfirmModal} />

                                            <div id="stack-iterms" >
                                                <AddRemoveClaims longClaimList={longClaimList} setLongClaimList={setLongClaimList} cycle={cycle} setErrorMsg={setErrorMsg} setOpenSnackBar={setOpenSnackBar} claimable={claimable} />
                                            </div>

                                            <div id="stack-iterms" >
                                                {reward}
                                                <small>reward</small>
                                            </div>

                                        </div>
                                    </div>

                                ))
                            }
                            {loading
                                ? <div>Loading...</div>
                                : ((stackHistory.length > 0) && !stackPageEnded) && <Button sx={{ color: 'white', borderColor: '#6444fe' }} variant='outlined' onClick={requestStackingHistory}>Load More</Button>
                            }

                        </CustomTabPanel>
                    </Box>
                    <div className="elSpacer">
                        <div />
                    </div>
                </div>

            </div>

            {/* Alert */}
            <Snackbar open={openSnackBar} autoHideDuration={6000} onClose={() => setOpenSnackBar(false)}>
                <Alert onClose={() => setOpenSnackBar(false)} severity="error" sx={{ width: '100%' }}>
                    {errorMsg}
                </Alert>
            </Snackbar>

            {/* Modals */}
            {showConfirmModal && <ConfirmModal show={showConfirmModal} setShow={setShowConfirmModal} close={() => setShowConfirmModal(false)} txId={confirmTx} userSettings={userSettings} />}
            <UserContractDeployModal show={showUserContractDeployModal} setShow={setShowUserContractDeployModal} txId={txId} setTxId={setTxId} setTx_Id={setConfirmTx} userContractStatus={userContractStatus} setUserContractStatus={setUserContractStatus} openConfirmModal={setShowConfirmModal} userSettings={userSettings} />
        </>
    );
}

export default StackRewards;